import { ai } from "./modules/ai";
import { admin } from "./modules/admin";
import { eversign } from "./modules/eversign";
import { publicApi } from "./modules/publicApi";
import { shared } from "./modules/shared";
import { meetingbot } from "./modules/meetingbot";
import { twilio } from "./modules/twilio";
import { stripeFunctions } from "./modules/stripe";
import { bankFunctions } from "./modules/bank";
import { codebotFunctions } from "./modules/codebot";

interface ApiClient {
  ai: typeof ai;
  admin: typeof admin;
  eversign: typeof eversign;
  public: typeof publicApi;
  shared: typeof shared;
  meetingbot: typeof meetingbot;
  twilio: typeof twilio;
  stripe: typeof stripeFunctions;
  bank: typeof bankFunctions;
  codebot: typeof codebotFunctions;
}

export const apiClient: ApiClient = {
  ai,
  admin,
  eversign,
  public: publicApi,
  shared,
  meetingbot,
  twilio,
  stripe: stripeFunctions,
  bank: bankFunctions,
  codebot: codebotFunctions,
};
